export default "https://fenwan.cdn.bcebos.com/gamecenter/static/game/assets/imgs/tb-vip-coupon.9fbbee85.png";